module.exports = __webpack_public_path__ + "img/logo.c0e8f14d.png";